define('tableDynamicTextFieldView',[
  'app',
  'module', 
  'underscore',
  'settings',
  'tableFieldView',
  'entities/dynamic_text'
], function (
  App,
  Module,
  _,
  Settings,
  FieldView
) {
  'use strict';

  Module.exports = FieldView.extend({
    className: 'table-field-view table-field-dynamic-text-view',

    onRender: function() {
      if(this.options.field.bind && this.model.get(this.options.field.value) ) {
        var dynamicTextModel = this.model.get(this.options.field.value);
        this.$el.html(dynamicTextModel.getTextInLocale(Settings.get('lang')));
      }
    }
  });
});
